// extracted by mini-css-extract-plugin
module.exports = {"header":"header--35HAt","header-title":"header-title--2EQ3m","headerTitle":"header-title--2EQ3m"};